import React, { Fragment, useRef } from "react";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";

function Hotline() {
  const tawkMessengerRef = useRef();

  return (
    <Fragment>
      <a className="items-chat-icon ic_mess" href="https://m.me/shopdunk.store" target="_blank">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none">
          <path
            d="M6.68715 17.2624C7.88236 18.4658 9.14893 19.5533 10.4868 20.525C11.8248 21.4878 13.1627 22.2499 14.5006 22.8115C15.8474 23.3821 17.1229 23.6673 18.3271 23.6673C19.1566 23.6673 19.9236 23.5202 20.6283 23.2261C21.3329 22.9319 21.9751 22.4728 22.5549 21.8488C22.876 21.4833 23.1391 21.0866 23.3443 20.6587C23.5583 20.2308 23.6654 19.8029 23.6654 19.3751C23.6654 19.072 23.5985 18.7778 23.4647 18.4925C23.3398 18.1984 23.1257 17.9488 22.8225 17.7437L18.9291 15.0026C18.6526 14.7975 18.3895 14.6504 18.1398 14.5613C17.8989 14.4632 17.6626 14.4142 17.4307 14.4142C17.1542 14.4142 16.8776 14.49 16.6011 14.6415C16.3336 14.7931 16.0571 15.0115 15.7716 15.2967L14.8618 16.1793C14.7281 16.313 14.5675 16.3798 14.3802 16.3798C14.2821 16.3798 14.1884 16.3665 14.0992 16.3397C14.019 16.3041 13.9431 16.2729 13.8718 16.2461C13.4882 16.0411 12.9888 15.6845 12.3733 15.1764C11.7579 14.6683 11.1335 14.0978 10.5002 13.4648C9.86694 12.8319 9.29164 12.2079 8.77431 11.5928C8.2659 10.9688 7.91358 10.4652 7.71735 10.0818C7.68167 10.0105 7.65046 9.93475 7.6237 9.85452C7.59694 9.77429 7.58356 9.68515 7.58356 9.58709C7.58356 9.4088 7.646 9.25726 7.77087 9.13246L8.66728 8.20982C8.9527 7.90673 9.17123 7.62147 9.32286 7.35404C9.47449 7.08661 9.5503 6.80581 9.5503 6.51163C9.5503 6.28878 9.49679 6.057 9.38975 5.81631C9.29164 5.56671 9.14447 5.29928 8.94824 5.01402L6.25902 1.21651C6.03603 0.913418 5.77291 0.690559 5.46965 0.547929C5.16638 0.405299 4.84528 0.333984 4.50634 0.333984C3.65007 0.333984 2.84286 0.699473 2.08471 1.43045C1.47818 2.0188 1.03221 2.674 0.746787 3.39607C0.470283 4.10922 0.332031 4.86694 0.332031 5.66923C0.332031 6.87267 0.608535 8.14296 1.16154 9.48012C1.72347 10.8173 2.48162 12.15 3.43601 13.4782C4.39931 14.8064 5.48302 16.0678 6.68715 17.2624Z"
            fill="#339901"
          />
        </svg>
      </a>

      <a className="items-chat-icon ic_tel" href="tel:19006626">
        <img
          src="https://shopdunk.com/images/uploaded-source/icon/ic_messenger.png"
          width="28px"
          height="28px"
        />
      </a>

      <TawkMessengerReact
        ref={tawkMessengerRef}
        propertyId="6389ad54b0d6371309d23fb5"
        widgetId="1gj8sq4p8"
        customStyle={{
          visibility: {
            desktop: {
              xOffset: "20",
              yOffset: "20",
              position: "br",
            },
            mobile: {
              xOffset: "20",
              yOffset: "20",
              position: "br",
            },
          },
        }}
      />
    </Fragment>
  );
}

export default Hotline;
